module.exports = __webpack_public_path__ + "img/1.f6747ae7.jpg";